module.exports = {
  title: '物流用户-查看',
  route: {
    path: '/user-manage',
    children: {
      path: 'logistics-user-details',
    },
  },
};
